import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACK_END_URL
});

axiosInstance.defaults.withCredentials = true;
axiosInstance.interceptors.request.use((config) => {
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {

    if (error.toJSON().message === 'Network Error') {
      return Promise.reject({ err: { msg: NetworkError } });
    } else if (408 === error.response.status) {
      return Promise.reject({ err: { msg: sessionTimeout } });
    } else if (403 === error.response.status) {
      return Promise.reject({ err: { msg: noPermission } });
    } else if (502 === error.response.status) {
      //for validation
      return Promise.reject((error.response && error.response.data));
    } else if (406 === error.response.status) {
      return Promise.reject((error.response && error.response.data));
    } else {
      if ((400 === error.response.status && error?.response?.data?.err?.msg === 'principal is null or empty') ||
        (400 === error.response.status && error?.response?.data?.err?.msg === sessionCutOff)) {
        return Promise.reject({ err: { msg: sessionTimeout } });
      } else {
        if (error?.response?.data?.err?.msg.includes('attachment')) {
          return Promise.reject({ err: { msg: error?.response?.data?.err?.msg } });
        } else {
          //Nina removed displaying of stacktrace for security purposes
          // return Promise.reject("Something went wrong!");
          return Promise.reject({ err: { code: error?.response?.data?.err?.code, msg: error?.response?.data?.err?.msg } });
        }

      }
    }
  }
);

export const sessionTimeout = "session timeout";
export const noPermission = "no permission";
export const NetworkError = "Please check your internet connection!";
export const sessionCutOff = 'com.vcc.camelone.common.exception.ProcessingException: com.vcc.camelone.common.exception.EntityNotFoundException: java.lang.Exception: principal is null'


export default axiosInstance;
